export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 order-2 lg:order-1">
            <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20editorial%20workspace%20scene%20with%20multiple%20glowing%20screens%20displaying%20abstract%20data%20visualizations%2C%20warm%20red%20amber%20accent%20lighting%2C%20modern%20newsroom%20atmosphere%2C%20professional%20broadcast%20environment%2C%20cinematic%20photography%2C%20dramatic%20shadows%2C%20no%20text%20no%20faces%20no%20people&width=500&height=350&seq=about-platform-visual&orientation=squarish"
                alt="每日黑料网平台介绍 - 专业的黑料吃瓜内容聚合导航"
                onError={(e) => { const el = (e.currentTarget as HTMLElement); if (el.parentElement) el.parentElement.style.display = 'none'; }}
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div className="flex-1 order-1 lg:order-2">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              关于每日黑料
            </h2>
            <div className="space-y-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                每日黑料网诞生于吃瓜群众的真实需求——在这个信息爆炸的时代，娱乐八卦和争议爆料遍布微博、豆瓣、抖音、小红书等各个平台，想要全面掌握最新最热的黑料动态变得越来越困难。
              </p>
              <p>
                我们的使命很简单：<strong className="text-foreground-900">做中文互联网最全面、最及时的黑料吃瓜内容导航入口。</strong>
                平台不生产内容，而是通过智能聚合和人工筛选，将散落在各处的热点爆料汇聚一处，
                让每位吃瓜群众都能一站式掌握全网最劲爆的瓜。
              </p>
              <p>
                从顶流明星的恋情实锤到网红带货的翻车现场，从综艺节目的幕后内幕到直播圈的互撕大戏，
                每日黑料网始终站在吃瓜第一线。我们坚持客观呈现多方信源，鼓励理性吃瓜、文明讨论，
                反对人身攻击和网络暴力。吃瓜本是消遣，开心最重要。
              </p>
            </div>
            <div className="flex flex-wrap gap-4 mt-6">
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <span className="w-8 h-8 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-xs font-bold">日</span>
                每日更新
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <span className="w-8 h-8 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center text-xs font-bold">全</span>
                全网覆盖
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <span className="w-8 h-8 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-xs font-bold">免</span>
                永久免费
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}